export default __webpack_public_path__ + "static/media/brand-logo.dee2d5e2.png";